<script setup lang="ts">
import translaters from "@/tradutors/assine";
import { isMobile } from "@/shared/utils/mobile";
const route = useRoute();
const reactiveLocale = computed(() => route.params.language); // Certifique-se de que locale é uma ref
const cupom = computed(() => (route.query["coupon-discount"] as string) || "");
const storeUser = userStore();

const translate = computed(() => {
  if (reactiveLocale.value === "pt-br") {
    return translaters.portugues;
  } else {
    return translaters.ingles;
  }
});

const props = defineProps({
  discount: {
    required: true,
  },
});

function copyToClipboard() {
  if (cupom.value) {
    navigator.clipboard.writeText(cupom.value);
    alert(reactiveLocale.value === "pt-br" ? "Copiado!" : "Copied!");
  } else {
    alert(
      reactiveLocale.value === "pt-br"
        ? "Nenhum cupom encontrado!"
        : "No coupon found!"
    );
  }
}
</script>
<template>
  <ClientOnly>
    <div class="container-fluid" v-if="!storeUser.isActiveUser">
      <div class="row banner-box mt-4">
        <div
          class="col-lg-2 col-4 d-flex justify-content-center align-items-center"
        >
          <!--                
          <div>
            <div class="banner-discount-1">{{ discount }}%</div>
            <div class="banner-discount-2">OFF</div>
          </div>
          -->        
        </div>
        <div class="col-lg-5 d-flex align-items-center" v-if="!isMobile()">
          <div>
            <div class="text1">{{ translate.bannerText1 }}</div>
            <div class="text2">{{ translate.bannerText2 }}</div>
          </div>
        </div>
        <div
          class="col-lg-3 d-flex justify-content-center align-items-center"
          v-if="!isMobile()"
        >
          <div
            class="banner-cupom d-flex align-items-center"
            @click="copyToClipboard"
          >
            {{ cupom }}
            <font-awesome
              :icon="['far', 'copy']"
              size="sm"
              class="banner-copy"
            />
          </div>
        </div>
        <!--        
        <div
          class="col-lg-2 d-flex justify-content-center align-items-center"
          v-if="!isMobile()"
        >

          <div>
            <div class="banner-discount-1">{{ discount }}%</div>
            <div class="banner-discount-2">OFF</div>
          </div>
        </div>
        -->        
        <div class="col-12 d-flex align-items-center" v-if="isMobile()">
          <div>
            <div class="text1">{{ translate.bannerText1 }}</div>
            <div class="banner-cupom d-flex align-items-center" @click="copyToClipboard">
              {{ cupom }}
              <font-awesome
                :icon="['far', 'copy']"
                size="sm"
                class="banner-copy"
              />
            </div>
            <div class="text2">{{ translate.bannerText2 }}</div>
          </div>
        </div>
      </div>
    </div>
  </ClientOnly>
</template>

<style scoped lang="css">
.banner-box {
  position: relative;
  background: linear-gradient(
    90deg,
    rgba(212, 82, 2, 1) 0%,
    rgba(255, 96, 0, 1) 50%,
    rgba(212, 82, 2, 1) 100%
  );
  height: 115px;
}

.banner-discount-1 {
  font-family: "Exo-2";
  font-weight: 900;
  color: #ffffff;
  font-size: 50px;
  line-height: 45px;
  vertical-align: middle;
}

.banner-discount-2 {
  font-family: "Exo-2";
  font-weight: 900;
  color: #ffffff;
  font-size: 55px;
  line-height: 50px;
  vertical-align: middle;
}

.text1 {
  font-family: "Exo-2";
  font-weight: 500;
  color: #ffffff;
  font-size: 27px;
  line-height: 35px;
  vertical-align: middle;
}

.text2 {
  font-family: "Exo-2";
  font-weight: 400;
  color: #ffffff;
  font-size: 15px;
  line-height: 23px;
  vertical-align: middle;
}

.banner-cupom {
  height: 58px;
  border-style: dashed;
  border: 1px dashed #ffffff;
  font-family: "Exo-2";
  font-weight: 600;
  font-size: 34px;
  line-height: 100%;
  vertical-align: middle;
  color: #ffffff;
  padding: 0 10px;
  background-color: #ea7832;
  cursor: pointer;
}

.banner-copy {
  color: #000000;
  padding-left: 10px;
}
/* regras mobile 769px */
@media screen and (max-width: 769px) {
  .banner-box {
    height: 165px;
  }

  .text1 {
    text-align: center;
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
  }

  .text2 {
    font-size: 10px;
    text-align: center;
  }

  .banner-cupom {
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 5px;
    font-size: 20px;
    height: 39px;
  }

  .banner-discount-1 {
    font-size: 40px;
    line-height: 33px;
  }

  .banner-discount-2 {
    font-size: 45px;
    line-height: 40px;
  }
}
</style>
